export default __webpack_public_path__ + "static/media/pro-source.ef7e3f91.jpeg";